import React, { useEffect, useState } from "react";
import { withFirebase } from "../../firebase";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

import PickupControl from "./pickupControl";

const PickupControlContainer = (props) => {
	const cities = useSelector((state) => state.shops.shops);
	const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
	const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));

	const adminPermission = JSON.parse(localStorage.getItem("adminPermission"));
	const isNewAdmin = adminPermission?.newAdmin;
	const deliveryTerminals = isNewAdmin
		? cities[currentCity]?.brands[currentBrand]?.deliveryTerminals
		: cities[currentCity]?.deliveryTerminals;

	const [terminals, setTerminals] = useState(deliveryTerminals);

	const onSubmit = () => {
		const isValidTerminals = !!terminals.find((item) => item.isActive === true);
		const ref = isNewAdmin
			? `/web/settings/city/${currentCity}/brands/${currentBrand}/deliveryTerminals`
			: `/web/settings/city/${currentCity}/deliveryTerminals`;
		if (isValidTerminals) {
			props.firebase.bd
				.ref(ref)
				.update(terminals)
				.then(() => {
					alert("Готово");
				})
				.catch((error) => {
					console.error("Error updating terminals:", error);
					alert("Щось пішло не так, спробуйте ще раз");
				});
		} else {
			alert("Мінімум один термінал повинен бути активний");
		}
	};

	useEffect(() => {
		deliveryTerminals && setTerminals(deliveryTerminals);
	}, [deliveryTerminals]);

	return (
		<div>
			{terminals && (
				<PickupControl
					terminals={terminals}
					setTerminals={setTerminals}
					saveData={onSubmit}
				/>
			)}
		</div>
	);
};

export default withRouter(withFirebase(PickupControlContainer));
